import './e-reviews-list.scss';
import './slider';
